// extracted by mini-css-extract-plugin
export default {"container":"styles_container__hJ7nJ","subtitle":"styles_subtitle__LNcTc","paragraph":"styles_paragraph__3AcOF"};